import {RawParams, UIRouterReact} from '@uirouter/react';

export class StateService {
  protected _router?: UIRouterReact;

  get router(): UIRouterReact | undefined {
    return this._router;
  }

  set router(router: UIRouterReact | undefined) {
    this._router = router;
  }

  go(state: string, params?: RawParams) {
    if (!this._router) {
      return;
    }
    this._router.stateService.go(state, params);
  }
}
